module.exports = __webpack_public_path__ + "static/media/buttonCutout.69f796ae.svg";